<template>
  <div class="flex flex-wrap home-dashboards">
    <div class="w-full last-100-courses search-hundred-loading vs-con-loading__container">
      <h3>Last 50 courses published</h3>
      <div class="flex flex-wrap mt-5" v-show="instructorsPieChart.series.length">
        <div class="w-1/2 px-5 instructors">
          <vx-card class="overflow-hidden">
            <h4 class="card-title">
                Instructors
            </h4>
            <vue-apex-charts ref="hundredInstructors" type="pie" height="350" :options="instructorsPieChart.chartOptions" :series="instructorsPieChart.series"></vue-apex-charts>
          </vx-card>
        </div>
        <div class="w-1/2 px-5 vendors">
          <vx-card class="overflow-hidden">
            <h4 class="card-title">
                Vendors
            </h4>
            <vue-apex-charts ref="hundredVendors" type="pie" height="350" :options="vendorsPieChart.chartOptions" :series="vendorsPieChart.series"></vue-apex-charts>
          </vx-card>
        </div>
        <div class="w-1/2 px-5 mt-10 difficulty">
          <vx-card class="overflow-hidden">
            <h4 class="card-title">
                Difficulty
            </h4>
            <vue-apex-charts type="radar" height="400" :options="radarChart.chartOptions" :series="radarChart.series"></vue-apex-charts>
          </vx-card>
        </div>
        <div class="w-1/2 px-5 mt-10 l-areas">
          <vx-card class="overflow-hidden">
            <h4 class="card-title">
                Learning Areas
            </h4>
            <vue-apex-charts ref="hundredLAreas" type="donut" height="350" :options="lareasChart.chartOptions" :series="lareasChart.series"></vue-apex-charts>
          </vx-card>
        </div>
      </div>
      
    </div>
    
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import isEmpty from "lodash.isempty";
import { pastelColors } from '@/utils/utils.js'
import VueApexCharts from 'vue-apexcharts'
import { COURSE_POSSIBLE_DIFFICULTY } from '@/store/course/state.js'
import { getBasicData } from '@/utils/mixins.js'

export default {
  components: {
    VueApexCharts
  },
  mixins: [getBasicData],
  data: () => {
    return {
      pageSize: 5,
      hundredResult: {
        total: 0,
        items: []
      },
      hundredInstructors: {},
      hundredVendors: {},
      hundredLAreas: {},
      instructorsPieChart: {
        series: [],
        chartOptions: {
          labels: [],
          colors: [],
        }
      },
      vendorsPieChart: {
        series: [],
        chartOptions: {
          labels: [],
          colors: [],
        }
      },
      radarChart: {
        series: [],
        chartOptions: {
          colors: ['#7367F0'],
          labels: Object.values(COURSE_POSSIBLE_DIFFICULTY),
        }
      },
      lareasChart: {
        series: [],
        chartOptions: {
          labels: [],
          colors: [],
        }
      }
    }
  },
  computed: {
    ...mapGetters('courses', ['getHundredCourses']),
    getInstructorsNames() {
      if (!isEmpty(this.hundredInstructors)) {
        return Object.keys(this.hundredInstructors)
      }
      return []
    },
    getInstructorsNumbers() {
      if (!isEmpty(this.hundredInstructors)) {
        return Object.values(this.hundredInstructors)
      }
      return []
    },
    getInstructorsColors() {
      if (this.getInstructorsNames && this.getInstructorsNames.length) {
        return this.getInstructorsNames.map(() => pastelColors())
      }
      return []
    },
    getVendorsNames() {
      if (!isEmpty(this.hundredVendors)) {
        return Object.keys(this.hundredVendors)
      }
      return []
    },
    getVendorsNumbers() {
      if (!isEmpty(this.hundredVendors)) {
        return Object.values(this.hundredVendors)
      }
      return []
    },
    getVendorsColors() {
      if (this.getVendorsNames && this.getVendorsNames.length) {
        return this.getVendorsNames.map(() => pastelColors())
      }
      return []
    },
    getLAreasNames() {
      if (!isEmpty(this.hundredLAreas)) {
        return Object.keys(this.hundredLAreas)
      }
      return []
    },
    getLAreasNumbers() {
      if (!isEmpty(this.hundredLAreas)) {
        return Object.values(this.hundredLAreas)
      }
      return []
    },
    getLAreasColors() {
      if (this.getLAreasNames && this.getLAreasNames.length) {
        return this.getLAreasNames.map(() => pastelColors())
      }
      return []
    }
  },
  methods: {
    ...mapActions("courses", ["searchCourses"]),
    ...mapMutations("courses", {
      saveHundredCourses: 'SAVE_HUNDRED_COURSES',
    }),
    async hundredCourses(payload = {}) {
      let response = null
      const hundredResponse = this.getHundredCourses

      if (hundredResponse) {
        response = hundredResponse
      } else {
        payload = {
          ...payload,
          status: 'published',
          page_size: '50',
          ordering: "-created"
        }
        this.$vs.loading({
          container: '.search-hundred-loading',
          scale: 0.6
        })
        response = await this.search(payload)
        
        this.$vs.loading.close('.search-hundred-loading > .con-vs-loading')
        this.saveHundredCourses(response)
      }

      if (this.$refs.hundredInstructors) {
        this.hundredResult.total = response.count;
        this.hundredResult.items = response.results;
        this.flattItems(this.hundredResult.items)

        this.$refs.hundredInstructors.updateOptions({ labels: this.getInstructorsNames });
        this.$refs.hundredInstructors.updateOptions({ colors: this.getInstructorsColors });
        this.instructorsPieChart.series = this.getInstructorsNumbers

        this.$refs.hundredVendors.updateOptions({ labels: this.getVendorsNames });
        this.$refs.hundredVendors.updateOptions({ colors: this.getVendorsColors });
        this.vendorsPieChart.series = this.getVendorsNumbers

        this.$refs.hundredLAreas.updateOptions({ labels: this.getLAreasNames });
        this.$refs.hundredLAreas.updateOptions({ colors: this.getLAreasColors });
        this.lareasChart.series = this.getLAreasNumbers
      }

    },
    async search(payload = {}) {
      try {
        const response = await this.searchCourses(payload);
        return response
      } catch (error) {
        this.showError(error)
      }
    },
    isEmpty() {
      return isEmpty;
    },
    flattItems(courses) {
      let instructors = {}
      let vendors = {}
      let lareas = {}
      let difficulty = Object.values(COURSE_POSSIBLE_DIFFICULTY).reduce((acc, d) => {
        acc[d] = 0
        return acc
      }, {})
      for (let index = 0; index < courses.length; index++) {
        const element = courses[index];
        if (element.instructors.length) {
          element.instructors.map(i => {
            instructors[this.getInstructorsEntries[i].name] = (instructors[this.getInstructorsEntries[i].name] || 0) + 1
          })
        }
        if (element.vendor) {
          vendors[this.getVendorsEntries[element.vendor].name] = (vendors[this.getVendorsEntries[element.vendor].name] || 0) + 1
        }
        if (element.difficulty) {
          difficulty[element.difficulty] += 1
        }
        if (element.learning_areas.length) {
          element.learning_areas.map(i => {
            lareas[this.getLAreasEntries[i].name] = (lareas[this.getLAreasEntries[i].name] || 0) + 1
          })
        }
      }
      this.hundredInstructors = Object.keys(instructors).sort().reduce((r, k) => (r[k] = instructors[k], r), {});
      this.hundredVendors = Object.keys(vendors).sort().reduce((r, k) => (r[k] = vendors[k], r), {});
      this.hundredLAreas = Object.keys(lareas).sort().reduce((r, k) => (r[k] = lareas[k], r), {});
      this.radarChart.series.push({
        name: 'Difficulty',
        data: Object.values(difficulty),
      })
    }
  },

  async mounted() {
    try {
      this.$vs.loading()

      // @mixin
      await this.getBasicData();


      this.$nextTick()
        .then(() => {
          this.$vs.loading.close();
        })

      await this.hundredCourses();
      
      // Load the static filtered searches
    } catch (error) {
      this.$vs.loading.close();
      this.showError(error)
    }
  },
};
</script>
<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>